<template>
  <div>
    <ValidationObserver ref="languageDetailsForm">
      <v-row>
        <v-col
          class="col-8 input-item"
          v-if="!isEdit"
          :class="{ 'col-12': isMobile }"
        >
          <ValidationProvider v-slot="{ errors }" rules="required">
            <Select
              item-text="name"
              item-value="id"
              v-model="language.id"
              label="Language"
              placeholder=""
              :items="allLanguages"
              :error-messages="getErrorMessages(errors)"
              :loading="isFetchingAllLanguages"
              autocomplete
            />
          </ValidationProvider>
        </v-col>
        <v-col
          class="col-4 input-item"
          :class="{ 'col-12': isEdit || isMobile }"
        >
          <ValidationProvider v-slot="{ errors }" rules="required">
            <Select
              item-text="name"
              item-value="id"
              v-model="language.level"
              label="Level"
              placeholder=""
              :items="languageLevels"
              :error-messages="getErrorMessages(errors)"
              :loading="isFetchingLanguageLevels"
              autocomplete
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select from "@/components/common/Select";
import { LANGUAGES_AND_SKILLS_NAMESPACE } from "@/store/modules/users/languagesAndSkills";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import {
  FETCH_ALL_LANGUAGES,
  FETCH_LANGUAGE_LEVELS
} from "@/store/modules/users/languagesAndSkills/actions";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const {
  mapActions,
  mapState: mapLanguagesAndSkillsState
} = createNamespacedHelpers(LANGUAGES_AND_SKILLS_NAMESPACE);

const INITIAL_LANGUAGE_DATA = {
  id: "",
  level: ""
};

export default {
  name: "NewLanguage",
  components: {
    Select,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    initialData: Object,
    isEdit: Boolean
  },
  data() {
    return {
      showValidationErrors: false,
      language: { ...INITIAL_LANGUAGE_DATA },
      isLoading: false
    };
  },
  created() {
    if (this.initialData) {
      this.language = { ...this.initialData };
    }
    this.fetchLanguageLevels();
    if (!this.isEdit) {
      this.fetchAllLanguages();
    }
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    }),
    ...mapLanguagesAndSkillsState(
      copyState([
        "isFetchingAllLanguages",
        "isFetchingLanguageLevels",
        "allLanguages",
        "languageLevels"
      ])
    )
  },
  methods: {
    ...mapActions({
      fetchAllLanguages: FETCH_ALL_LANGUAGES,
      fetchLanguageLevels: FETCH_LANGUAGE_LEVELS
    }),
    clearForm() {
      this.showValidationErrors = false;
      this.language = { ...INITIAL_LANGUAGE_DATA };
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    getData() {
      return this.language;
    },
    async validate() {
      this.showValidationErrors = true;
      return this.$refs.languageDetailsForm.validate();
    }
  }
};
</script>

<style lang="scss"></style>
